import { apiRequest } from "../../../framework/network/api-client";
import { Id } from "../../../models/framework/db";
import { Poll, PollComment, PollType, UserPollLink } from "../../../models/poll";
import { ApiUrlPath as AUP } from "../../url-paths";
import {
    AddCommentResponse,
    CreatorInfo,
    FeedPollGetReq,
    PollBotVoteReq,
    PollCard,
    PollGetRes,
    PollIdReq,
    PollTrackRequest,
    PollVoteResponse,
    StatusResponse,
} from "./poll-req-models";

let creators: { [key: string]: CreatorInfo } = {};

export const pollAdd = async (body: Id<Poll>, host?: string) =>
    await apiRequest<{ status: boolean; pollId: string }>(AUP.pollAdd, body, host);

export const getPolls = async (body: FeedPollGetReq) => {
    const pollRes = await apiRequest<PollGetRes>(AUP.pollGet, body);

    pollRes.pollList.map((poll) => {
        if (poll.creator) {
            if (poll.creatorId in creators) {
                if (poll.creator !== creators[poll.creatorId]) {
                    poll.creator = creators[poll.creatorId];
                }
            } else {
                creators[poll.creatorId] = poll.creator;
            }
        }
    });

    return pollRes;
};

export const votePoll = async (body: UserPollLink) =>
    await apiRequest<PollVoteResponse>(AUP.pollVoteAdd, body);

export const addComment = async (body: PollComment) =>
    await apiRequest<AddCommentResponse>(AUP.commentAdd, body);

export const getComments = async (body: { pollId: string }) =>
    await apiRequest<Array<Id<PollComment>>>(AUP.commentList, body);

export const getScriptPolls = async (body: {}) =>
    await apiRequest<Array<Id<Poll>>>(AUP.scriptPollGet, body);

export const getPollVote = async (body: { pollId: string }) =>
    await apiRequest<Array<UserPollLink>>(AUP.scriptPollVoteGet, body);

export const trackPoll = async (body: PollTrackRequest) =>
    await apiRequest<StatusResponse>(AUP.pollTrack, body);

export const botVote = async (body: PollBotVoteReq) =>
    await apiRequest<{ status: boolean }>(AUP.scriptPollBotVote, body);

export const updateScriptPollType = async (body: { pollType: PollType; pollId: string }) =>
    await apiRequest<{ status: boolean }>(AUP.scriptPollUpdate, body);

export const pollDelete = async (body: PollIdReq) =>
    await apiRequest<StatusResponse>(AUP.pollDelete, body);

export const pollImpressionAdd = async (body: PollIdReq) =>
    await apiRequest<StatusResponse>(AUP.pollImpressionAdd, body);

export const getQuestionCollection = async (body: Object) =>
    await apiRequest<{ questionList: string[] }>(AUP.pollCollectionGet, body);

export const getImageCollection = async (body: Object) =>
    await apiRequest<{ imageSrcList: string[] }>(AUP.pollImageCollectionGet, body);

export const getPollById = async (body: { pollId: string }) =>
    await apiRequest<{ poll?: Id<PollCard> }>(AUP.pollGetById, body);
